import IPath from 'interfaces/IPath'
import { FC } from 'react'

import { useTranslation } from 'next-i18next'

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import Section from 'components/Section/Section'
import Triforce from './Triforce/Triforce'
import Graph from './Graph/Graph'

import styles from './OurStoryInNumbers.module.scss'

interface IOurNumbers {
  breadcrumbs?: IPath[]
  host?: string
}

const OurNumbers: FC<IOurNumbers> = ({ breadcrumbs, host }) => {
  const { t } = useTranslation(['stats', 'contacts'])
  return (
    <Section backgroundClass={styles.background}>
      <div className={styles.ourNumbers}>
        <div className={styles.heroText}>
          {breadcrumbs?.length > 0 && (
            <Breadcrumbs path={breadcrumbs} host={host} white className={styles.heroBreadcrumbs} />
          )}
          <h1 className={styles.title}>{t('stats:ourStoryTitle')}</h1>
          <h2 className={styles.subtitle}>{t('stats:ourStoryTitle')}</h2>
        </div>
        <div className={styles.heroMedia}>
          <div className={styles.graph}>
            <Graph />
          </div>
          <div className={styles.triforce}>
            <Triforce />
            <div className={styles.percentsWrapper}>
              <div className={styles.percents}>78%</div>
              <div className={styles.percents}>40%</div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default OurNumbers
